import type { ReportPerformance } from '../../../api/playerReports'

export function PerformanceSummary({
  performance,
}: {
  performance: ReportPerformance[]
}) {
  return (
    <div className="report-performance">
      {performance.map((p) => (
        <article className="report-panel" key={p.scenario}>
          <div className="report-performance-stat">
            <p className="report-eyebrow">{p.label}</p>
            {p.success_rate !== null ? (
              <>
                <p className="report-ratio">
                  {p.successes}
                  <span> / {p.resolved}</span>
                </p>
                <p className="report-muted">
                  {p.scenario === 'passing' || p.scenario === 'pases'
                    ? 'resueltos correctamente'
                    : 'terminaron en gol'}
                </p>
                <div
                  className="report-meter"
                  role="img"
                  aria-label={`${p.successes} de ${p.resolved} intentos con resultado fueron aciertos`}
                >
                  <span style={{ width: `${p.success_rate}%` }} />
                </div>
              </>
            ) : (
              <p className="report-muted">
                Todavía no hay resultados evaluables.
              </p>
            )}
          </div>
          <div className="report-performance-detail">
            <dl className="report-outcomes">
              {p.outcomes.map((o) => (
                <div key={o.label}>
                  <dt>{o.label}</dt>
                  <dd>{o.count}</dd>
                </div>
              ))}
            </dl>
            {p.trials > p.resolved && (
              <p className="report-caption">
                {p.trials - p.resolved}{' '}
                {p.trials - p.resolved === 1
                  ? 'registro sin resultado evaluable'
                  : 'registros sin resultado evaluable'}
                . Se muestran aparte de los intentos.
              </p>
            )}
          </div>
        </article>
      ))}
    </div>
  )
}
